module.exports = __webpack_public_path__ + "img/k.7b3d6485.png";